import React, { useEffect } from 'react';
import styled from 'styled-components';
import FAQ from './FAQ';
import NewRouteline from './NewRouteline';
import { observer } from 'mobx-react';
import VideoCarousel from './VideoCarousel';
import Landing from './Landing';
import { useLocation } from 'react-router-dom';

const Wrapper = styled.div`
    .shadow {
        box-shadow: 0px 23px 30px 0px rgba(54, 103, 123, 0.2);
    }
`;

const InnerContent = styled.div`
    padding-bottom: 100px;
    &.noPaddingBotton {
        padding-bottom: 0;
    }
`;

const TimeLineWrapper = styled.div`
    width: 100%;
    /* margin-top: 60px; */
`;

const TimeLineAndFaqWrapper = styled.div`
    width: 100%;
    position: relative;
    background-size: cover;
    background-position: center -700px;
    background-repeat: no-repeat;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding-top: 10px;
    `};
`;

function Home() {
    const location = useLocation();

    useEffect(() => {
        // Handle scroll from other pages
        const state = location.state as { scrollTo?: string; scrollOffset?: number } | null;
        if (state?.scrollTo) {
            const offset = state.scrollOffset || 0;
            const scrollContainer = document.getElementById('globalContainer');

            // Retry mechanism to wait for element to render
            let retryCount = 0;
            const maxRetries = 20;
            const retryInterval = 100;

            const tryScroll = () => {
                const scrollToElement = document.getElementById(state.scrollTo!);
                if (scrollToElement && scrollContainer) {
                    // Element found, perform scroll
                    setTimeout(() => {
                        const elementRect = scrollToElement.getBoundingClientRect();
                        const containerRect = scrollContainer.getBoundingClientRect();
                        const absoluteElementTop = elementRect.top + scrollContainer.scrollTop - containerRect.top;
                        const scrollPosition = absoluteElementTop + offset;

                        scrollContainer.scrollTo({
                            top: Math.max(0, scrollPosition),
                            behavior: 'smooth',
                        });
                    }, 200);
                } else if (retryCount < maxRetries) {
                    // Element not found yet, retry
                    retryCount++;
                    setTimeout(tryScroll, retryInterval);
                }
            };

            // Start trying to scroll after a short delay to ensure page is loaded
            setTimeout(tryScroll, 100);
        }
    }, [location.state]);

    return (
        <Wrapper>
            <Landing />
            <TimeLineAndFaqWrapper>
                <TimeLineWrapper>
                    <NewRouteline />
                </TimeLineWrapper>
                <InnerContent>
                    <VideoCarousel />
                    <FAQ />
                </InnerContent>
            </TimeLineAndFaqWrapper>
        </Wrapper>
    );
}

export default observer(Home);
